import { useDispatch, useSelector } from 'react-redux';
import { selectIsOrgAdmin, selectUserId } from 'core/userContext';
import { useUpdateOrganizationMember } from 'api/OrganizationAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { MemberModal } from './MemberModal';
import {
  MemberFormSchema,
  MemberFormProvider,
  createMemberPayload,
} from '../../contexts/MemberFormProvider';
import {
  useOrganizationModalsContext,
  MemberPayload,
} from '../../contexts/OrganizationModalsContext';
import { useOrganizationMembersQueryContext } from '../../contexts/OrganizationMembersQueryContext';
import { Member } from '../../types';
import { fullName } from '../../utils';

export const EditMemberModal = () => {
  const dispatch = useDispatch();
  const isOrgAdmin = useSelector(selectIsOrgAdmin);
  const currentUserId = useSelector(selectUserId);
  const { refetchAll } = useOrganizationMembersQueryContext();
  const { modalState, hideModal } = useOrganizationModalsContext();

  const { member } = modalState?.payload as MemberPayload;

  const includeRoleAndPermissionsFields = isOrgAdmin && member.userId !== currentUserId;

  const { mutate, isLoading } = useUpdateOrganizationMember(member.userId, {
    onSuccess: () => {
      dispatch(addPositiveToast(`Details for ${fullName(member)} were updated successfully.`));
      refetchAll();
      hideModal();
    },
    onError: (error: unknown) => {
      const msg = `There was an error updating details for ${fullName(member)}. Please try again.`;
      dispatch(addNegativeToastWithErrorId(msg, 'updateMember', error));
    },
  });

  const onSubmit = (values: MemberFormSchema) => {
    const payload = createMemberPayload(values);
    mutate(payload as Member);
  };

  return (
    <MemberFormProvider member={member}>
      <MemberModal
        id="edit-member-modal"
        headerText="Edit details"
        confirmBtnText="Save"
        onSubmit={onSubmit}
        isLoading={isLoading}
        disableEmailInput={true}
        includeRoleAndPermissionsFields={includeRoleAndPermissionsFields}
      />
    </MemberFormProvider>
  );
};
